module.exports = __webpack_public_path__ + "img/Info_blue.02169049.svg";